<h1 mat-dialog-title *ngIf="data.userData && data.userData.id">Edit User</h1>
<h1 mat-dialog-title *ngIf="!data.userData">Add New User</h1>

<div mat-dialog-content>
    <form [formGroup]="Form">

	<mat-form-field class="user-id-box" appearance="outline" *ngIf="data.userData && data.userData.id">
		<mat-label>User ID</mat-label>
		<input matInput formControlName="id" readonly required>
		<!-- <mat-hint>User id cannot be changed.</mat-hint>	 -->
		<div class="user-id-tooltip">User id cannot be changed</div>
	</mat-form-field>

	<mat-form-field appearance="outline" *ngIf="!data.userData">
		<mat-label>Userid (Unique code or email address)</mat-label>
		<input matInput formControlName="id" required (keyup)="changeInIdField()">
	</mat-form-field>

	<div class="marginArea" style="flex-basis: 100%;">
		<mat-slide-toggle color="primary" formControlName="status" (change)="changeUserStatus($event)">Status</mat-slide-toggle>
	</div>

    <!-- Name field -->
    <mat-form-field appearance="outline">
        <mat-label>Name</mat-label>
        <input matInput formControlName="name" required>
    </mat-form-field>

	<mat-form-field appearance="outline" class="example-full-width">
		<mat-label>Email</mat-label>
		<input matInput formControlName="email" *ngIf="data.userData" readonly>
		<input matInput formControlName="email" *ngIf="!data.userData">
		<!-- <mat-error *ngIf="f.description.invalid">Please enter description</mat-error> -->
	</mat-form-field>

	<mat-form-field appearance="outline" class="example-full-width">
		<mat-label *ngIf="data.userData">Enter New Password (Please leave blank if you want to keep the old one)</mat-label>
		<mat-label *ngIf="!data.userData">Password</mat-label>
		<input matInput type="password" formControlName="password" autocomplete="new-password" [required]="!data.userData">
		<mat-error *ngIf="Form.controls['password'].hasError('minlength')">Password must be at least 8 characters.</mat-error>
		<mat-error *ngIf="Form.controls['password'].hasError('maxlength')">Password cannot exceed 128 characters.</mat-error>
	</mat-form-field>

	<mat-form-field appearance="outline">
		<mat-label>Select Role</mat-label>
		<mat-select formControlName="roleId">
			<mat-option *ngFor="let item of rolesData" [value]="item.id" (click)="changeRole(item)">{{item.name}}</mat-option>
		</mat-select>
	</mat-form-field>

	<ng-container *ngFor="let orgLevel of organisationHierarchy; let i = index">
		<mat-form-field appearence="outline">
			<mat-label>Select {{ orgLevel.name }}</mat-label>
			<mat-select [value]="levelValue(i)">
				<mat-option *ngIf="i >= 1" value="none" (click)="changeLevelOption(i, orgLevel.name, 'none')">None</mat-option>
				<mat-option *ngFor="let tempLevel of uniqueOrgLevelValues(orgLevel.values, i)" [value]="tempLevel.value" (click)="changeLevelOption(i, orgLevel.name, tempLevel.value)">
					{{ this.capitalizeFirstWord(tempLevel.value) }}
				</mat-option>
			</mat-select>
		</mat-form-field>
	</ng-container>

	<mat-form-field appearance="outline">
        <mat-label>Select Group</mat-label>
        <mat-select formControlName="groupId" (selectionChange)="changeGroup($event.value)">
          <mat-option *ngFor="let item of groupsData" [value]="item.id">{{item.name}}</mat-option>
        </mat-select>
    </mat-form-field>

	<mat-form-field appearance="outline" class="example-full-width" *ngIf="data.userData && data.userData.createdAt">
		<mat-label>Created At</mat-label>
		<input matInput formControlName="createdAt" required readonly>
		<!-- <mat-error *ngIf="f.description.invalid">Please enter description</mat-error> -->
	</mat-form-field>

	<mat-form-field appearance="outline" class="example-full-width" *ngIf="data.userData && data.userData.updatedAt">
		<mat-label>Updated At</mat-label>
		<input matInput formControlName="updatedAt" required readonly>
		<!-- <mat-error *ngIf="f.description.invalid">Please enter description</mat-error> -->
	</mat-form-field>

	<button style="height: 42px;
    width: 264px;" *ngIf="isUserAdmin()" mat-button (click)="deleteUserProgress(data.userData.id)">
		Delete User Progress
	</button>
</form>
</div>

<div mat-dialog-actions style="display: flex;justify-content: flex-end;">
	<button mat-button mat-dialog-close>Cancel</button>
	<button mat-button cdkFocusInitial (click)="saveBtn()">Save</button>
</div>
